var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("../../assets/images/pages/iralex-logo.svg"),"alt":"","width":"120","height":"120"}})
}
var staticRenderFns = []

export { render, staticRenderFns }